<template>
  <div style="font-size: 14px; font-family: Arial, sans-serif; margin-left: 6px" id="content_ticket">
    <div style="width: 100%; text-align: center; margin-top: 5px; margin-bottom: 10px;">
      <img v-if="is_imprimir_logo_en_tickets" :src="logo" style="width: 75%">
    </div>

    <hr v-if="is_imprimir_logo_en_tickets" style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

    <div style="width: 100%; text-align: left; margin-top: 5px;">
      <div>{{ centro.razon_social }}</div>
      <div>{{ centro.direccion_social }}</div>
      <div>{{ centro.codigo_postal_social }} {{ centro.localidad_social }}</div>
      <div>{{ centro.telefono_modificar_cita }}</div>
      <div v-if="centro.cif">{{$t('NIF:')}}{{' '}}{{ centro.cif }}</div>
    </div>

    <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

    <slot name="content"></slot>

    <hr style="border: 1px dashed #000000; width: 100%; margin: 5px 0"/>

    <div class="text-center" style="width: 100%; text-align: left; white-space: pre-line;">
      {{ texto_pie_ticket_regalo }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintTicketRegaloLayout',
  data() {
    return {
      is_imprimir_logo_en_tickets: null,
      texto_pie_ticket_regalo: ""
    }
  },
  async mounted() {
    await this.get_configuracion_venta()

  },
  methods: {
    /**
     * Obtenermos la configuración de venta del centro
     * @returns {Promise<void>}
     */
    async get_configuracion_venta() {
      try {
        let result = await this.$store.dispatch('configuraciones/get', 'venta')
        this.is_imprimir_logo_en_tickets = result.is_imprimir_logo_en_tickets
        this.texto_pie_ticket_regalo = result.texto_pie_ticket_regalo

      } catch (err) {
      }
    },

  },
  computed: {
    logo() {
      if (this.$store.state.centro.centro.logo_absolute_path) {
        return this.$store.state.centro.centro.logo_absolute_path
      }
      return this.$store.state.centro.centro.empresa.logo_absolute_path
    },
    centro() {
      return this.$store.state.centro.centro
    }
  }
}
</script>

<style lang="scss" scoped>
@page {
  size: auto;   /* auto is the current printer page size */
  margin: 0;  /* this affects the margin in the printer settings */
}

body {
  background-color: #FFFFFF;
  margin: 0; /* the margin on the content before printing */
}

#content_ticket {
  font-family: Arial, sans-serif;
  margin-left: 6px;
  line-height: 1.2;
  color: #000000 !important;
}
</style>
